import { useCallback } from 'react';

import { LOCAL_STORAGE } from '@/constants';

const resolveFormattingLocale = (): string => {
    const stored = localStorage.getItem(LOCAL_STORAGE.LANGUAGE_KEY);
    if (stored) {
        return stored.replace(/_/g, '-');
    }
    const htmlLang = document.documentElement.getAttribute('lang');
    if (htmlLang) {
        return htmlLang.replace(/_/g, '-').slice(0, 2);
    }
    return 'en-US';
};

const useDateFormatter = () => {

    const formatDate = useCallback((_value: string | number, _format: string): string => {
        const date = new Date(_value);
        const locale = resolveFormattingLocale();

        if (isNaN(date.getTime())) {
            return '';
        }

        let formattedDate = '';

        if (_format === 'mediumDate') {

            formattedDate = new Intl.DateTimeFormat(locale, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            }).format(date);
        } else if (_format === 'medium') {

            formattedDate = new Intl.DateTimeFormat(locale, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
            }).format(date);
        } else if (_format === 'historyDateTime') {
            formattedDate = new Intl.DateTimeFormat(locale, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            }).format(date);
        }

        return formattedDate;
    }, []);

    return { formatDate };
};

export { useDateFormatter };
